import React, { useCallback, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { equals, lensProp, set } from "ramda";
import { notBlank, notEmpty } from "../../../util/ext";

import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import RichTextField from "../../common/RichTextField";
import { MediaContext } from "../../common/media-context";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    flexBasis: "50%",
  },

  header: {
    color: "black",
    fontSize: "2rem",
    fontFamily: "Nunito,sans-serif",
    fontWeight: "bolder",
    lineHeight: "2.6rem",
  },

  buttonArea: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  rte: {
    borderWidth: 0,
    fontFamily: "inherit",
    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
    borderRadius: "0",
    resize: "vertical",
    overflowY: "auto",
    minHeight: 249,

    "& a": {
      color: theme.palette.primary.main,
    },
  },

  form: {
    marginTop: 0,
  },

  formControl: {
    transform: "translate(0, -32px)",
  },
}));

const Description = props => {
  const {
    enableLinks = false,
    className,
    required = false,
    error,
    helperText,
  } = props;
  const classes = useStyles();
  const context = useContext(MediaContext);

  const description = notBlank(context.media.descriptionText)
    ? context.media.descriptionText
    : context.media.description;

  const handleTextChange = useCallback(
    ({ text, html }) => {
      if (equals(context.media.mediaType, "module")) {
        context.setMedia(prev => set(lensProp("description"), html, prev));
      } else {
        context.setMedia(prev => set(lensProp("description"), text, prev));
        context.setMedia(prev => set(lensProp("descriptionText"), html, prev));
      }
    },
    [context],
  );

  return (
    <FormControl
      className={className || classes.root}
      required={required}
      error={error}
    >
      <InputLabel
        classes={{ root: classes.header, formControl: classes.formControl }}
      >
        Description
      </InputLabel>
      {notEmpty(context.media) && (
        <div className={classes.form}>
          <Grid container alignItems="flex-end">
            <Grid item xs={12}>
              <RichTextField
                isUpload
                enableLinks={enableLinks}
                label="Description"
                value={description}
                onChange={handleTextChange}
                className={classes.rte}
                error={error}
                helperText={helperText}
              />
            </Grid>
          </Grid>
        </div>
      )}
    </FormControl>
  );
};

export default Description;
